export const links = {
    supersend_item_view: (
        partnerMid: string,
        supersendMid: string,
        itemMid: string,
    ) =>
        `/api/partner/${partnerMid}/sending/order/${supersendMid}/item/${itemMid}/file-view/`,
    supersend_items_fileinfo: (partnerMid: string, supersendMid: string) =>
        `/api/partner/${partnerMid}/sending/order/${supersendMid}/items/file-info/`,
};
